import mapEditorSectionToUrl from './mapEditorSectionToUrl';

// @note sections used to build survey with blocks @feshchenko
export default [
  mapEditorSectionToUrl.landing,
  mapEditorSectionToUrl.survey,
  mapEditorSectionToUrl.ty,
];
